module.exports = __webpack_public_path__ + "static/media/bill-to-ship-to-edit-title.557a9c97.png";